// client/src/features/auth/GoogleCredentialButton.jsx

import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import {
  Alert,
  Box,
} from '@mui/material';


const GOOGLE_SCRIPT_ID =
  'google-identity-services';


const GoogleCredentialButton = ({
  onCredential,
  disabled = false,
  text = 'continue_with',
  width = 340,
}) => {
  const buttonRef = useRef(null);
  const callbackRef = useRef(onCredential);

  const [
    error,
    setError,
  ] = useState('');


  useEffect(() => {
    callbackRef.current = onCredential;
  }, [onCredential]);


  useEffect(() => {
    const clientId =
      process.env.REACT_APP_GOOGLE_CLIENT_ID;

    if (!clientId) {
      setError(
        'Google authentication is not configured.'
      );

      return;
    }


    if (disabled) {
      if (buttonRef.current) {
        buttonRef.current.innerHTML = '';
      }

      return;
    }


    const initializeGoogle = () => {
      if (
        !window.google?.accounts?.id ||
        !buttonRef.current
      ) {
        return;
      }


      window.google.accounts.id.initialize({
        client_id: clientId,

        auto_select: false,

        callback: (response) => {
          if (response?.credential) {
            callbackRef.current?.(
              response.credential
            );
          }
        },
      });


      buttonRef.current.innerHTML = '';


      window.google.accounts.id.renderButton(
        buttonRef.current,
        {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          shape: 'pill',
          text,
          width,
        }
      );
    };


    if (window.google?.accounts?.id) {
      initializeGoogle();
      return;
    }


    let script =
      document.getElementById(
        GOOGLE_SCRIPT_ID
      );


    if (!script) {
      script =
        document.createElement('script');

      script.id =
        GOOGLE_SCRIPT_ID;

      script.src =
        'https://accounts.google.com/gsi/client';

      script.async = true;
      script.defer = true;

      document.head.appendChild(script);
    }


    script.addEventListener(
      'load',
      initializeGoogle
    );


    return () => {
      script?.removeEventListener(
        'load',
        initializeGoogle
      );
    };
  }, [
    disabled,
    text,
    width,
  ]);


  return (
    <Box>
      {error && (
        <Alert
          severity="error"
          sx={{
            mb: 2,
          }}
        >
          {error}
        </Alert>
      )}

      <Box
        ref={buttonRef}
        sx={{
          minHeight: '44px',

          display: 'flex',

          justifyContent: 'center',

          opacity:
            disabled
              ? 0.5
              : 1,

          pointerEvents:
            disabled
              ? 'none'
              : 'auto',
        }}
      />
    </Box>
  );
};


export default GoogleCredentialButton;